import { useLanguage } from "@/contexts/LanguageContext"
import { Linkedin, Instagram } from "lucide-react"

const Footer = () => {
  const year = new Date().getFullYear()
  const { t } = useLanguage()
  const links = [
    { href: "/#services", label: t('footer.services') },
    { href: "/#process", label: t('footer.process') },
    { href: "/#projects", label: t('footer.projects') },
    { href: "/#contact", label: t('footer.contact') },
    { href: "/rejoindre", label: t('nav.joinTeam') },
  ]
  return (
    <footer className="bg-je-black text-je-white">
      <div className="container-editorial py-20">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-10 rounded-sm bg-je-red flex items-center justify-center font-serif font-bold text-lg">JE</span>
              <span className="font-serif text-2xl font-medium">HEPIA<span className="text-je-red">.</span></span>
            </div>
            <p className="font-serif text-2xl md:text-3xl font-medium leading-tight max-w-xl text-balance">
              {t('footer.description')}
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-widest text-je-white/40 mb-4">Navigation</div>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.href}><a href={l.href} className="text-je-white/80 hover:text-je-red transition-colors text-sm">{l.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-widest text-je-white/40 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-je-white/80">
              <li><a href="mailto:je.hepia@hesge.ch" className="hover:text-je-red transition-colors">je.hepia@hesge.ch</a></li>
              <li>Rue de la Prairie 4<br />1202 Genève · CH</li>
            </ul>
            <div className="flex gap-2 mt-5">
              <a href="https://www.linkedin.com/company/jehepia/" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 border border-je-white/15 hover:border-je-red hover:text-je-red flex items-center justify-center rounded-sm transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/jehepia/?hl=fr" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 border border-je-white/15 hover:border-je-red hover:text-je-red flex items-center justify-center rounded-sm transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-je-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs font-mono text-je-white/50 uppercase tracking-wider">
          <span>© {year} {t('footer.copyright')}</span>
          <div className="flex gap-6">
            <a href="#" className="hover:text-je-white">{t('footer.legal')}</a>
            <a href="#" className="hover:text-je-white">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-je-white">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer
